module.exports = __webpack_public_path__ + "img/6.cf373e5b.jpg";